import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["id", "value", "multi", "items", "itemMap", "selectedItem", "initialSelectedItem", "initialSelectedItems", "getItemId", "itemToString", "stateReducer", "onStateChange", "setFilterInputValue", "setSelectedItems", "onChange", "onBlur"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState } from 'react';
import { useCombobox } from 'downshift';
import { removeUndefined } from '../utils';
import { defaultFreeformItem, defaultGetItemId, defaultItemToString, defaultStateReducer } from '../utils/defaults';
import { noop } from 'lodash';
import { useStateReactors } from './use-state-reactors';
export function useDownshift(_ref) {
  var _context;

  var id = _ref.id,
      value = _ref.value,
      multi = _ref.multi,
      items = _ref.items,
      itemMap = _ref.itemMap,
      controlSelectedItem = _ref.selectedItem,
      initialSelectedItem = _ref.initialSelectedItem,
      initialSelectedItems = _ref.initialSelectedItems,
      _ref$getItemId = _ref.getItemId,
      getItemId = _ref$getItemId === void 0 ? defaultGetItemId : _ref$getItemId,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? defaultItemToString : _ref$itemToString,
      _ref$stateReducer = _ref.stateReducer,
      propStateReducer = _ref$stateReducer === void 0 ? defaultStateReducer : _ref$stateReducer,
      propOnStateChange = _ref.onStateChange,
      setFilterInputValue = _ref.setFilterInputValue,
      setSelectedItems = _ref.setSelectedItems,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(noop),
      _useState2 = _slicedToArray(_useState, 2),
      scrollToIndex = _useState2[0],
      setScrollToIndex = _useState2[1];

  var _useStateReactors = useStateReactors({
    itemMap: itemMap,
    multi: multi,
    items: items,
    initialSelectedItems: initialSelectedItems,
    getItemId: getItemId,
    itemToString: itemToString,
    stateReducer: propStateReducer,
    onStateChange: propOnStateChange,
    onChange: onChange,
    onBlur: onBlur,
    scrollToIndex: scrollToIndex,
    setFilterInputValue: setFilterInputValue,
    setSelectedItems: setSelectedItems
  }),
      stateReducer = _useStateReactors.stateReducer,
      onStateChange = _useStateReactors.onStateChange;

  var _useCombobox = useCombobox(removeUndefined(_objectSpread(_objectSpread({}, props), {}, {
    id: id,
    // Always send the default freeform item to downshift and
    // deal with disabling the interaction in the menu
    items: _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(items), [defaultFreeformItem]),
    // Control props
    selectedItem: controlSelectedItem,
    // Initial state
    initialSelectedItem: initialSelectedItem,
    // Behaviour overrides
    itemToString: itemToString,
    stateReducer: stateReducer,
    // Don't use downshift to scroll items into view
    scrollIntoView: noop,
    // State extrators
    onStateChange: onStateChange
  }))),
      isOpen = _useCombobox.isOpen,
      highlightedIndex = _useCombobox.highlightedIndex,
      inputValue = _useCombobox.inputValue,
      selectedItem = _useCombobox.selectedItem,
      reset = _useCombobox.reset,
      openMenu = _useCombobox.openMenu,
      closeMenu = _useCombobox.closeMenu,
      selectItem = _useCombobox.selectItem,
      setInputValue = _useCombobox.setInputValue,
      getToggleButtonProps = _useCombobox.getToggleButtonProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getMenuProps = _useCombobox.getMenuProps,
      getInputProps = _useCombobox.getInputProps,
      getItemProps = _useCombobox.getItemProps;

  return {
    isOpen: isOpen,
    highlightedIndex: highlightedIndex,
    inputValue: inputValue,
    selectedItem: selectedItem,
    reset: reset,
    openMenu: openMenu,
    closeMenu: closeMenu,
    selectItem: selectItem,
    setInputValue: setInputValue,
    getToggleButtonProps: getToggleButtonProps,
    getComboboxProps: getComboboxProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getItemProps: getItemProps,
    setScrollToIndex: setScrollToIndex
  };
}